import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderLink2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderLink2"><Path d="M2.5 10.5V3.5H10L12 6.5H21.5V19.5H14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.75 13.5H1.5V20.5H4.75M8.25 13.5H11.5V20.5H8.25" stroke="currentColor" strokeLinecap="square"/><Path d="M5.25 17H7.75" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFolderLink2;
